






















































































import {
  defineComponent, computed, ref,
} from '@vue/composition-api';
import type { PropType, SetupContext } from '@vue/composition-api';
import {
  Popup, Dialog, Tabs, TabItem as Tab,
} from '@hb/coffee';
import { DetailsOutline16 } from '@hb/coffee-icons';
import { RouteMarketEnum, FundListDataType } from '@/api/apply-product/types';
import RepayPlanDetail from './components/RepayPlanDetail/index.vue';
import DebtConsultingDetail from './components/DebtConsultingDetail/index.vue';
import type { RepayDialogDataType } from './types';

export default defineComponent({
  components: {
    Popup,
    Tabs,
    Tab,
    DetailsOutline16,
    RepayPlanDetail,
    DebtConsultingDetail,
  },
  props: {
    show: Boolean,
    data: {
      type: Object as PropType<RepayDialogDataType>,
      default: () => ({}),
      required: true,
    },
    /** 串型资金方名称，以「、」隔开，eg：'xxx、xxx' */
    capitalName: {
      type: String,
      default: '',
      required: false,
    },
    /** 多资方列表，目前仅众安小贷有此模式 */
    fundListData: {
      type: Array as PropType<FundListDataType[]>,
      default: () => [],
      required: false,
    },
    currentCheckFundIndex: {
      type: Number,
      default: 0,
      required: false,
    },
    repayOnSchedule: {
      type: Boolean,
      default: false,
      required: false,
    },
    isSimplifiedListStyle: {
      type: Boolean,
      default: false,
    },
    /** 父容器高度 */
    containerHeight: {
      type: Number,
      default: 0,
    },
    /** 是否需要安全区域底部, 快速提现场景需要传true */
    safeAreaBottom: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['handler', 'close', 'changeFund'],
  setup(props: {
    show: boolean;
    data: RepayDialogDataType;
    capitalName: string;
    fundListData: FundListDataType[];
    currentCheckFundIndex: number;
    repayOnSchedule: boolean;
    isApplyOptimizeExperiment: boolean;
  }, { emit }: SetupContext) {
    /** 当前选中的 Tab 索引 */
    const currentTabIndex = ref<number>(0);

    /** 判断是否有债务咨询费 */
    const hasDebtConsulting = computed(() => props.data.debtConsultingTotalAmount
        && Number(props.data.debtConsultingTotalAmount) > 0);

    /** 处理 Tab 切换 */
    const handleTabChange = (index: number) => {
      currentTabIndex.value = index;
    };

    /** 借款关联费用数据 */
    const loanRelatedData = computed(() => ({
      ...props.data,
      shouldPayAmount: props.data.loanRelatedAmount
        ? Number(props.data.loanRelatedAmount)
        : props.data.shouldPayAmount,
    }));

    /** 债务咨询费数据 */
    const debtConsultingData = computed(() => ({
      ...props.data,
      shouldPayAmount: props.data.debtConsultingTotalAmount
        ? Number(props.data.debtConsultingTotalAmount)
        : 0,
    }));

    /** 资方是否超过一家 */
    const isMoreThanOneFund = computed(() => props.capitalName.split('、').length > 1);

    const checkFundData = (index: number) => {
      emit('changeFund', index);
    };

    const selectRepaymentType = (item: string) => {
      emit('handler', item);
    };

    const showRepayTipConfirm = () => {
      if (!isMoreThanOneFund.value) return;
      Dialog.alert({
        title: '还款计划说明',
        message: `我们与${props.capitalName}等多家金融机构合作，在您发起借款后将在以上合作机构中为您匹配放款机构，最终展示以实际放款机构为准`,
      }).finally(() => {
        Dialog.close();
      });
    };

    const handleClose = () => {
      emit('close');
    };

    return {
      currentTabIndex,
      hasDebtConsulting,
      loanRelatedData,
      debtConsultingData,
      handleTabChange,
      isMoreThanOneFund,
      checkFundData,
      selectRepaymentType,
      showRepayTipConfirm,
      handleClose,
      RouteMarketEnum,
    };
  },
});
